/**
 * <s-sticky-buy> — Mobile buy bar that appears only after the main Add to cart row
 * ([data-main-buy] in the same form) has scrolled above the viewport, and hides when it returns.
 * It lives inside the product form, so its submit button sends the same input[name="id"].
 * It mirrors [data-add-to-cart-error] visually so errors stay visible while the main panel is off screen.
 */
class StickyBuy extends HTMLElement {
  #observer;
  #errorObserver;

  connectedCallback() {
    const form = this.closest('form');
    const target = form?.querySelector('[data-main-buy]');
    if (!target) return;

    this.inert = true;
    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      this.#toggle(scrolledPast);
    });
    this.#observer.observe(target);

    const error = this.closest('s-product-form')?.querySelector('[data-add-to-cart-error]');
    const mirror = this.querySelector('[data-sticky-error]');
    if (error && mirror) {
      const sync = () => {
        const message = error.hidden ? '' : error.textContent.trim();
        mirror.textContent = message;
        mirror.hidden = !message;
      };
      this.#errorObserver = new MutationObserver(sync);
      this.#errorObserver.observe(error, { attributes: true, childList: true, characterData: true, subtree: true });
      sync();
    }
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#errorObserver?.disconnect();
  }

  #toggle(show) {
    // Stay out of the way while the cookie consent banner is on screen.
    const banner = document.getElementById('shopify-pc__banner');
    const bannerVisible = banner && banner.offsetParent !== null;
    const visible = show && !bannerVisible;
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', StickyBuy);
